import { reactive } from 'vue'
import axios from 'axios'

const state = reactive({
    userid: '',
    email: '',
})

let fetched = false;
async function fetchUser() {
    if (fetched) return;
    fetched = true;
    try {
        const res = await axios.get('/api/me');
        state.userid = res.data.userid;
        state.email  = res.data.email;
    } catch {}
}

fetchUser();

export default { state }
